import { render } from "./Personas.vue?vue&type=template&id=86abfaaa&scoped=true"
import script from "./Personas.vue?vue&type=script&lang=js"
export * from "./Personas.vue?vue&type=script&lang=js"

import "./Personas.vue?vue&type=style&index=0&id=86abfaaa&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86abfaaa"]])

export default __exports__